module.exports = __webpack_public_path__ + "img/dining-tables.a73ce3f.jpg";